import "./style.scss";
import { FC } from "react";

interface ICustomSwitchProps {
  label: string;
  value: boolean | undefined;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

const CustomSwitch: FC<ICustomSwitchProps> = ({ label, value, onChange, disabled = false }) => {
  return (
    <label className={`custom-switch${disabled ? " is-disabled" : ""}`}>
      <p>{label}</p>
      <div
        className={`switch ${value ? "on" : "off"}`}
        onClick={() => {
          if (disabled) return;
          onChange(!value);
        }}
      >
        <div className={`thumb ${value ? "on" : "off"}`} />
      </div>
    </label>
  );
};

export default CustomSwitch;
